import $ from 'jquery';

export default function form() {

    $('.send-form').click(function () {
        if($('.wpcf7-form').hasClass("submitting")) {
            $('.send-form').prop('disabled',true);
            const myInterval = setInterval(function () {
                if($('.wpcf7-form').hasClass("sent")) {
                    $('.send-form').prop('disabled',false);
                    clearInterval(myInterval);
                }
            }, 5000);
        }
    });
}